export const COLORS = [
  '#5D58A2',
  '#E14733',
  '#49B4E9',
  '#E55288',
  '#F8A48E',
  '#A0E683',
  '#0079C0',
  '#9199EF',
  '#6DC4F1',
  '#FDB677',
  '#57EEC5',
  '#FF7775',
  '#A288BE',
  '#D8669E',
  '#4CB5AB',
  '#485460',
  '#0984E2',
  '#FAB1A0',
  '#a36979',
  '#d0e9dd',
  '#a2c2e3',
  '#bb8a79',
  '#e1b0be',
  '#81c7dd',
  '#8a86b5',
  '#978087',
  '#749fad',
  '#659398',
  '#ba88d3',
  '#87b36c',
  '#8ACECA',
  '#FDCA6E',
  '#364F6B',
  '#F378AA',
  '#82CDF3',
  '#A1CA88',
  '#A39BFE',
  '#D8E187',
  '#00B894',
  '#FFEAA7',
  '#51CFE4',
  '#E27056',
  '#558FA7',
  '#FE79A8',
  '#FCBAD3',
  '#6E5BE9',
  '#45CDCF',
  '#4BB3AC',
  '#F86364',
  '#FFDE7D',
  '#4CD0FA',
  '#40514E',
  '#FFDE59',
  '#CBF1F6',
  '#FB937A',
  '#B83B5E',
  '#01CDCA',
  '#4B5B70',
  '#F2B8A4',
  '#7CE6B5',
  '#EE8BAE',
  '#609CD4',
  '#F08266',
  '#74B8FF'
];

export function getColorArray(): Array<string> {
  return [...COLORS];
}

export class ColorGenerator {
  private index = -1;

  constructor(private colors: Array<string>, private zeroGray = false) {}

  public color(val?: number): string {
    if (this.zeroGray && val === 0) {
      return 'gray';
    }
    if (this.colors.length > this.index) {
      this.index++;
      return this.colors[this.index];
    }
    return 'gray';
  }

  public reset(): void {
    this.index = -1;
  }
}
